import { MatDialog } from '@angular/material/dialog';
import { AnexoVisualizarDialogComponent } from './anexo-visualizar-dialog.component';

export function abrirAnexoVisualizar(dialog: MatDialog, blob: Blob, nome: string): void {
  dialog.open(AnexoVisualizarDialogComponent, {
    width: '820px',
    maxWidth: '95vw',
    data: {
      blob,
      nome: nome || 'anexo',
    },
  });
}
